module.exports = __webpack_public_path__ + "static/monitor-568e234d8139e6b99b8d97539f84809e.jpg";